export const ADD = 'entities/campaign/ADD';
export const ADD_MULTIPLE = 'entities/campaign/ADD_MULTIPLE';
export const UPDATE = 'entities/campaign/UPDATE';
